<template>
  <div
    :class="`dummy tw-absolute tw-top-[66px] tw-bottom-0 tw-left-0 tw-right-0 tw-z-[1] tw-items-center tw-justify-center tw-flex tw-flex-col tw-gap-[25px] ${customClass}`"
  >
    <div
      :class="`tw-text-[#211F58] tw-font-[Poppins] tw-text-[16px] tw-leading-[135%] tw-text-center title ${titleClass}`"
    >
      {{ title }}
    </div>
    <b-button
      v-if="isShowButton"
      variant="primary"
      class="button-verify tw-bg-[#387DFF] tw-ml-[10px] tw-items-center tw-px-[20px] tw-text-[13px] tw-font-medium tw-rounded-[100px] tw-h-[36px]"
      type="submit"
      @click="handleActionButton"
    >
      {{ titleButton }}
    </b-button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  customClass: {
    type: String,
    required: false,
    default: "",
  },
  title: {
    type: String,
    default: "",
  },
  titleClass: {
    type: String,
    default: "",
  },
  titleButton: {
    type: String,
    default: "",
  },
  isShowButton: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["button:click"]);

const handleActionButton = () => {
  emit("button:click");
};
</script>

<style lang="scss" scoped>
.dummy {
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(12px);
  align-self: stretch;
}
</style>
